import { createAction, props } from '@ngrx/store';

export const loadClientList = createAction('[Client] Load List');

export const loadClientListSuccess = createAction(
  '[Client] Load List Success',
  props<{ data: any[] }>()
);

export const loadClientListFailure = createAction(
  '[Client] Load List Failure',
  props<{ error: any }>()
);

export const clearClientList = createAction('[Client] Clear List');
